import(/* webpackMode: "eager" */ "/var/www/html/Ariel/src/app/dashboard/auth/page.tsx");
